<template>
  <Modal
    title="Fechamento de caixa"
    :value="open"
    :onClose="close"
  >
    <ModalContent
      :close="close"
      v-if="open"
      :closeCheckout="closeCheckout"
    />
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import ModalContent from './ModalContent';

export default {
  name: 'ModalCloseCheckout',
  components: {
    Modal,
    ModalContent,
  },
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    closeCheckout: {
      required: true,
      type: Function,
    },
    close: {
      required: true,
      type: Function,
    },
  },
};
</script>

<style>

</style>
